<template>
    <div class="row">
        <div class="col">
            <card class="error" v-if="clientOrder.canceled_at">
                <card-content>
                    <span class="subtitle-1"><translate>Dieser Auftrag wurde storniert</translate></span>
                </card-content>
            </card>

            <card>
                <card-header>
                    <card-title>
                        <span><translate>Bestellung</translate> {{ askForQuote.pfnumber }}</span>
                    </card-title>
                </card-header>
                <card-content>
                    <table class="table table--stripped">
                        <thead>
                        <tr>
                            <th><translate>Projekttitel</translate></th>
                            <th><translate>Stück</translate></th>
                            <th><translate>Bestelldatum</translate></th>
                            <th><translate>Liefertermin</translate></th>
                            <th><translate>Nettopreis</translate></th>
                            <th><translate>19% USt.</translate></th>
                            <th><translate>Gesamtpreis<span>Brutto inkl. Versand</span></translate></th>
                            <th><translate>Zahlungsart</translate></th>
                            <th class="text-center"><translate>Fortschritt<span>Produzent</span></translate></th>
                            <th class="text-center"><translate>Status <span>Partfactory</span></translate></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{ clientOrder.project_name}} </td>
                            <td>{{ clientOrder.amount }} </td>
                            <td>{{ clientOrder.created_at }} </td>
                            <td>{{ clientOrder.delivery_at }} </td>
                            <td>{{ clientOrder.net_price }} </td>
                            <td>{{ clientOrder.ust }} </td>
                            <td>{{ clientOrder.offer_price }} </td>
                            <td>{{ clientOrder.payment_type }} </td>
                            <td class="text-center">
                                <production-progress-icons :producer-status="clientOrder.producer_status" />
                            </td>
                            <td class="text-center">{{ clientOrder.status }}</td>
                        </tr>
                        </tbody>
                    </table>
                </card-content>
                <card-content>
                    <div class="row">
                        <div class="col">
                            <card class="card--outline card--dense card--address">
                                <card-content>
                                    <p>
                                        <strong><translate>Rechnungsadresse</translate></strong><br>
                                        {{ askForQuote.ask_for_quote_invoice_address.company }}<br>
                                        {{ askForQuote.ask_for_quote_invoice_address.name }}<br>
                                        {{ askForQuote.ask_for_quote_invoice_address.street }}
                                        {{ askForQuote.ask_for_quote_invoice_address.street_no }}<br>
                                        {{ askForQuote.ask_for_quote_invoice_address.zip }}
                                        {{ askForQuote.ask_for_quote_invoice_address.city }}<br>
                                        {{ askForQuote.ask_for_quote_invoice_address.client_country.country_name }}
                                    </p>

                                </card-content>
                            </card>
                            <p v-if="askForQuoteInvoice">
                                <a :href="askForQuoteInvoice" class="btn btn--block btn--secondary"><translate>Rechnung herunterladen</translate></a>
                            </p>
                        </div>
                        <div class="col">
                            <card class="card--outline card--dense card--address">
                                <card-content>
                                    <p>
                                        <strong><translate>Lieferadresse</translate></strong><br>
                                        {{ askForQuote.ask_for_quote_delivery_address.company }}<br>
                                        {{ askForQuote.ask_for_quote_delivery_address.name }}<br>
                                        {{ askForQuote.ask_for_quote_delivery_address.street }}
                                        {{ askForQuote.ask_for_quote_delivery_address.street_no }}<br>
                                        {{ askForQuote.ask_for_quote_delivery_address.zip }}
                                        {{ askForQuote.ask_for_quote_delivery_address.city }}<br>
                                        {{ askForQuote.ask_for_quote_delivery_address.client_country.country_name }}
                                    </p>
                                </card-content>
                            </card>
                        </div>
                    </div>
                </card-content>
            </card>
        </div>
    </div>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardContent from '@partfactory/Shared/Card/CardContent';
import ProductionProgressIcons from '@partfactory/Shared/Elements/ProductionProgressIcons';
export default {
    name: 'ComponentOrder',
    components: {ProductionProgressIcons, CardContent, CardTitle, CardHeader, Card},
    props: {
        askForQuote: Object,
    },
    computed: {
        clientOrder() {
            return {
                'project_name': this.askForQuote.project_name,
                'amount': this.askForQuote.client_order.client_offer.amount,
                'created_at': this.$date(this.askForQuote.client_order.client_offer.created_at),
                'delivery_at': this.askForQuote?.client_late_delivery?.new_delivery_date ? this.$date(this.askForQuote?.client_late_delivery?.new_delivery_date) + ' ' +this.$gettext('(korrigiert)') : this.$date(this.askForQuote.client_order.delivery_at),
                'net_price': this.$currency(this.askForQuote.client_order.client_offer.net_price),
                'ust': this.$currency(this.askForQuote.client_order.client_offer.offer_price - this.askForQuote.client_order.client_offer.net_price),
                'offer_price': this.$currency(this.askForQuote.client_order.client_offer.offer_price),
                'payment_type': this.$readablePaymentType(this.askForQuote.client_order.payment_type),
                'status': this.$readableStatusClient(this.askForQuote.status),
                'producer_status': this.askForQuote?.producer_order?.producer_status,
                'canceled_at': this.askForQuote?.client_order?.canceled_at,
            };
        },
        askForQuoteInvoice() {
            return this.askForQuote.ask_for_quote_invoice ? this.$$route('ask-for-quote-documents.download', {'askForQuoteDocuments': this.askForQuote.ask_for_quote_invoice.id}) : null;
        },
    }
};
</script>

<style scoped>

</style>
